import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import * as cartConstants from '../cartConstants';

import AddToCart from '../AddToCart';
import {I18nMessage} from '../../I18n';
import {Tooltip} from '../../../global';
import {cartSelectors} from '../index';


function AddToCartContent({contentId, publicationId, status}) {

    const selectorCheck = {
        id: contentId,
        publicationId,
        status
    };

    const {canAdd, reason} = useSelector(state => cartSelectors.canContentBeAddedToCart(state, selectorCheck));

    return (
        <Tooltip
            contents={!canAdd && reason && (
                <>
                    <I18nMessage id={`cart.addTo.disabled.reason.${reason}.text`}/>
                </>
            )}
            id={`add-to-cart-content-${contentId}`}
            isActive={!canAdd}
        >
            <AddToCart
                isDisabled={!canAdd}
                item={
                    {
                        contentId,
                        itemType: cartConstants.CART_ITEM_TYPE_CONTENT
                    }
                }
            />
        </Tooltip>
    );
}


AddToCartContent.propTypes = {
    contentId: PropTypes.string.isRequired,
    publicationId: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
};

AddToCartContent.defaultProps = {};


export default AddToCartContent;
